module.exports = __webpack_public_path__ + "static/8-d497e4ebebc617f08a1569edc1dd8ff9.webp";